import { useApp } from 'hooks';
import { COLOR_SCHEME } from 'styles/colorScheme';

import * as S from './styles';

const OPTIONS = [
  { value: COLOR_SCHEME.system, label: 'System' },
  { value: COLOR_SCHEME.light, label: 'Light' },
  { value: COLOR_SCHEME.dark, label: 'Dark' },
];

export default function AppearanceSwitcher() {
  const { appearance } = useApp();

  return (
    <S.Options role="radiogroup" aria-label="Appearance">
      {OPTIONS.map(({ value, label }) => (
        <S.Option
          key={value}
          type="button"
          role="radio"
          aria-checked={appearance.scheme === value}
          isActive={appearance.scheme === value}
          onClick={() => appearance.setScheme(value)}
        >
          {label}
        </S.Option>
      ))}
    </S.Options>
  );
}
